import { render, staticRenderFns } from "./_newOrganization.vue?vue&type=template&id=234e9966&"
import script from "./_newOrganization.vue?vue&type=script&lang=js&"
export * from "./_newOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports